<div class="agentix-trial-signup-brand">
  <!-- <mat-icon class="agentix-trial-signup-brand__icon"
            svgIcon="agentix"
            aria-hidden="true"></mat-icon>
  <span class="agentix-trial-signup-brand__text">Addenda Agentix</span> -->
  <img src="assets/img/ai/ai-logo-addenda-agentix.svg"
       alt="Addenda Agentix"
       class="agentix-trial-signup-brand__logo">
</div>